// removed by extract-text-webpack-plugin
module.exports = {"selectorRoot":"CentricUI__components__WorkspaceChooser__selectorRoot","selectContainer":"CentricUI__components__WorkspaceChooser__selectContainer","customView":"CentricUI__components__WorkspaceChooser__customView","menu":"CentricUI__components__WorkspaceChooser__menu","bpMenu":"CentricUI__components__WorkspaceChooser__bpMenu","workspace":"CentricUI__components__WorkspaceChooser__workspace","preset":"CentricUI__components__WorkspaceChooser__preset","presetText":"CentricUI__components__WorkspaceChooser__presetText"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/siteHeader/components/WorkspaceChooser.css
// module id = 1695
// module chunks = 10